import React, { useEffect, useState } from "react";
import { after, isMobile } from "../common/Common";
import { ModalDetail } from "./common";
import { prepareDataForProopertyBox } from "../common/PropertyBox";
import Config from "config";

const mediaURLPrefix = Config.mediaURLPrefix;
const defaultThumbnailURL = Config.defaultThumbnailURL;

export const GallerySlide = React.memo((props) => {
  let propertyDetail = { ...props.propertyDetail };
  if (propertyDetail.PropertyMediaes == "") {
    propertyDetail.PropertyMediaes = null;
  }
  const [slideImages, setslideImages] = useState([]);

  const onLoad = after(slideImages.length * 3, () => {
    initPageJs();
  });

  const ReaderChild = (list, componentClassName) => {
    if (componentClassName) {
      list = list.map((property, index) => {
        return (
          <div
            className="swiper-slide"
            key={`${componentClassName + property.MediaPath}`}
          >
            <div className={componentClassName}>
              <img
              className="swiper-lazy"
                id={`${componentClassName + property.MediaPath}`}
                src={mediaURLPrefix + property.MediaPath}
                onLoad={onLoad}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = defaultThumbnailURL;
                  currentTarget.setAttribute("test", "test");
                  onLoad();
                }}
                alt={`${props.propertyName} ${index + 1}`}
                loading="lazy"
                data-kbct="open_popup"
                data-kblb="gallery"
                data-kbgp="gallery"
                data-kbsc="photo"
                data-kbid={propertyDetail.PropertyID}
              />
              <div class="g-loader"></div>
            </div>
          </div>
        );
      });
    } else {
      list = list.map((property, index) => {
        return (
          <div
            className="swiper-slide"
            key={`${componentClassName + property.MediaPath}`}
          >
            {/* <div className={componentClassName}> */}
            <img
              className="swiper-lazy"
              id={`${componentClassName + property.MediaPath}`}
              src={mediaURLPrefix + property.MediaPath}
              onLoad={onLoad}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultThumbnailURL;
                currentTarget.setAttribute("test", "test");
                onLoad();
              }}
              alt={`${props.propertyName} ${index + 1}`}
              loading="lazy"
              data-kbct="open_popup"
              data-kblb="gallery"
              data-kbgp="gallery"
              data-kbsc="photo"
              data-kbid={propertyDetail.PropertyID}
            />
            <div class="g-loader"></div>
            {/* </div> */}
          </div>
        );
      });
    }
    return list;
  };

  useEffect(() => {
    if (props.list && props.list.length > 0) {
      var imageTypes;

      if (isMobile()) {
        imageTypes = ["IMAGE-MOBILE", "MAP-MOBILE"];
      } else {
        imageTypes = ["IMAGE-PC", "MAP-PC"];
      }

      setslideImages(
        props.list
          .filter(function (media) {
            return imageTypes.indexOf(media.MediaType) !== -1;
          })
          .sort(function (a, b) {
            if (a.MediaType < b.MediaType || a.MediaPath < b.MediaPath) {
              return -1;
            } else if (a.MediaType > b.MediaType || a.MediaPath > b.MediaPath) {
              return 1;
            } else {
              return 0;
            }
          })
      );
    }
  }, [props.list]);
  console.log("GallerySlide Render length:", slideImages.length);

  var {
    propertyDetailURL,
    thumbnailURL,
    location,
    propertyName,
    tag,
    PromotionPrice,
    Price,
    areaHtml,
    bedRoomHtml,
    propertyTypeHtml,
    PropertyIDFormat,
    IsPartner,
  } = prepareDataForProopertyBox(propertyDetail);

  if (slideImages.length > 0) {
    return (
      <>
        <section>
          <div className="gallery-slide">
            <div className="swiper-wrapper">{ReaderChild(slideImages, "")}</div>

            <div className="gallery-content">
              <div className="gallery-container-1920">
                <div className="gallery-pagination">
                  <span className="p-current">1</span>
                  <span>/</span>
                  <span className="p-total">{slideImages.length}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div id="gallery-modal" className="gallery-backdrop">
          <div className="line-modal" />
          <div className="g-wrapper-col">
            <div className="g-modal-header mb">
              <h2>รายละเอียดทรัพย์</h2>
              <button type="button" className="close-gallery-modal">
                <img
                  src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
                  alt="close"
                />
              </button>
            </div>
            <div className="g-body">
              <div className="g-wrapper-col-l">
                <div
                  style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",
                  }}
                  className="swiper-container  gallery-modal-swiper"
                >
                  <div className="swiper-wrapper" data-kbct="click" data-kblb="swipe_photo" data-kbgp="gallery" data-kbsc="detail" data-kbid={propertyDetail.PropertyID}                  >
                    {ReaderChild(slideImages, "swiper-zoom-container")}
                  </div>
                  <div
                    className="swiper-button-next"
                    data-kbct="click"
                    data-kblb="swipe_photo"
                    data-kbgp="gallery"
                    data-kbsc="photo"
                    data-kbid={propertyDetail.PropertyID}
                  />
                  <div
                    className="swiper-button-prev"
                    data-kbct="click"
                    data-kblb="swipe_photo"
                    data-kbgp="gallery"
                    data-kbsc="photo"
                    data-kbid={propertyDetail.PropertyID}
                  />
                  <div className="g-name-property show-w1024">
                    <span>{propertyDetail.TitlePageName}</span>
                    <div className="g-page">
                      {/* {<span className="g-current-page">1</span>
                      <span>/</span>
                      <span className="g-total-page">{slideImages.length}</span>} */}
                    </div>
                  </div>
                </div>
              </div>
              <ModalDetail
                propertyDetail={propertyDetail}
                makeAnOfferClick={props.makeAnOfferClick}
              />
              {/* {<div className="g-wrapper-col-r">
                <div className="g-modal-header dt">
                  <h2>รายละเอียดทรัพย์</h2>
                  <button type="button" className="close-gallery-modal">
                    <img
                      src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
                      alt="close"
                    />
                  </button>
                </div>
                <div className="g-row-share">
                  <div className="g-page">
                    <span className="g-current-page">1</span>
                    <span>/</span>
                    <span className="g-total-page">{slideImages.length}</span>
                  </div>
                  <div className="g-share">
                    <i className="ic-npa ic-npa-icon-share" />
                    <span>แชร์</span>
                  </div>
                  <div className="g-wrapper-share">
                    <a
                      href={void 0}
                      onClick={fbShare}
                      className="share-item share-facebook d-flex justify-content-center align-items-center fab fa-facebook-f"
                    >
                      <i className="ic-npa ic-icon-facebook-bold" />
                    </a>
                    <a
                      href={void 0}
                      onClick={tweetShare}
                      className="share-item share-twitter d-flex justify-content-center align-items-center fab fa-twitter"
                    >
                      <i className="ic-npa ic-icon-x" />
                    </a>
                    <a
                      href={void 0}
                      onClick={lineMSG}
                      className="share-item share-line d-flex justify-content-center align-items-center fab fa-line"
                    >
                      <i className="ic-npa ic-icon-line-bold" />
                    </a>
                    <a
                      href={void 0}
                      onClick={mailShare}
                      className="d-flex justify-content-center align-items-center copy-button"
                    >
                      <i className="ic-npa ic-icon-link" />
                    </a>
                  </div>
                </div>
                <div className="g-detail">
                  <div>
                    <div className="wrap-asset-title">
                      <a href="javascript:;">
                        <h3 className="asset-title">{propertyName}</h3>
                      </a>
                    </div>
                    <div className="location">
                      <i className="ic-npa ic-npa-icon-pin" />
                      <p>{location}</p>
                    </div>
                    <div className="wrap-address">
                      <p className="asset-address">{propertyTypeHtml}</p>
                      <p className="asset-code">รหัส {propertyDetail.PropertyIDFormat}</p>
                    </div>
                    <div className="wrap-detail">
                      <div className="asset-room">{bedRoomHtml}</div>
                      <div className="asset-area">{areaHtml}</div>
                    </div>
                    <div className="wrap-price">
                      {tag}
                      <div className="price">
                        {PromotionPrice}
                        {Price}
                      </div>
                    </div>
                    <PriceWrapper {...propertyDetail} />
                    <div className="mobile-contact-wrapper">
                      <a
                        href="#"
                        className="btn-green popup-goto-contact show-w1024 pxtm-click-linkClick"
                        title="ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง"
                      >
                        ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง
                      </a>
                      <button
                        className="btn-main btn-first hide-w1024 pxtm-click-linkClick"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#contact-offcanvas"
                        aria-controls="contact-offcanvas"
                        title="ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง"
                      >
                        ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์
                      </button>
                      <a
                        href={props.makeAnOfferClick}
                        className="btn-white pxtm-click-linkClick"
                        title="เสนอราคาซื้อ_เอสเปช เกษตร - นวมินทร์"
                      >
                        เสนอราคาซื้อ
                      </a>
                    </div>
                  </div>
                </div>
              </div>} */}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}, areSlideImagesEqual);

function areSlideImagesEqual(prevProps, nextProps) {
  if (prevProps.list?.length !== nextProps.list?.length) {
    return false;
  }
  return true;
}
